<template>
    <div class="field grid-item grid-item-full" :class="styles" v-fs-block>
        <label
            v-if="hasLabel"
            class="typo__label" v-html="label"></label>

        <div class="grid-item grid-item-full grid-fitted btn-group">
            <template v-for="(option, index) in optionsList">
                <slot v-if="$slots.action"
                      :index="index"
                      :label="option.label"
                      :value="option.value"
                      :model="option.model"
                      :update="() => update(index)"/>
                <v-radio v-else
                         type="button-group"
                         class="grid-item"
                         :label="option.label"
                         :value="option.value"
                         :model="option.model"
                         :key="`${option.value}-${option.index}`"
                         @update="() => update(index)"></v-radio>
            </template>
        </div>
        <span v-if="helpText" class="field-caption" v-html="helpText"></span>
    </div>
</template>

<script>
    import vRadio from '@/components/form/v-radio';
    import vIcon from '@/components/form/v-icon';


    export default {
        name: 'v-group-select',
        components: {vRadio, vIcon},
        props: {
            options: {
                type: Array,
                required: true,
            },
            value: {
                type: [String, Array, Number],
                default: null,
            },
            label: {
                type: String,
                default: null,
            },
            validate: {
                type: Object,
                default: null,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
            allowEmpty: {
                type: Boolean,
                default: false,
            },
            helpText: {
                type: String,
            },
        },
        computed: {
            optionsList() {
                const model = (value) => {
                    if (this.multiple) {
                        return this.value.includes(value) ? value : null;
                    }
                    return this.value === value ? value : null;
                };
                return this.options.map(({value, label}) => ({
                    value,
                    label: label.toString(),
                    model: model(value),
                }));
            },
            styles() {
                return {
                    'is-error': this.isInvalid,
                    [`is-${this.type}`]: !!this.type,
                    [`is-multiple`]: !!this.multiple,
                };
            },
            hasLabel() {
                return (this.label || '').trim() !== '';
            },
            labelStyles() {
                return {
                    'is-disabled': this.disabled,
                    'is-checked': this.isChecked,
                };
            },
            isInvalid() {
                if (this.validate) {
                    return this.validate.$invalid && this.validate.$dirty;
                }
                return false;
            },
        },
        methods: {
            update(index) {
                const option = this.options[index];
                const {value} = this;

                // single value
                if (!this.multiple) {
                    if (value === option.value && this.allowEmpty) {
                        this.$emit('update', '');
                    } else if (value !== option.value) {
                        this.$emit('update', option.value);
                    }
                }
                // multiple value
                if (this.multiple) {
                    // value is array
                    if (value.includes(option.value)) {
                        value.splice(value.indexOf(option.value), 1);
                        this.$emit('update', value);
                    } else {
                        value.push(option.value);
                        this.$emit('update', value);
                    }
                }
            },
        },
    };
</script>
